module.exports = __webpack_public_path__ + "button-logout.svg?0356b6e99122b22ed22f91c62c554fdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button-logout.svg
// module id = 650
// module chunks = 0